import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { JwtService } from '../jwt.service';
import { ConfigService } from './config.service';
import { ClienteSingletonService } from '../singletons/cliente-singleton.service';
import { Banner } from '../persistences/banner';

@Injectable({
  providedIn: 'root'
})
export class BannerService {

  constructor(
    private configService: ConfigService,
    private httpClient: HttpClient,
    private jwtService: JwtService,
    private clienteSingletonService: ClienteSingletonService
  ) { }

  getAtivosPorFilial(): Observable<Banner[]> {
    this.jwtService.validarAcessToken();
    const cdFilial = this.clienteSingletonService.getClienteEstatico()?.getClienteFilial?.getCdFilial
      ?? parseInt(localStorage.getItem('filial_business') || '0');
    let httpParams = new HttpParams();
    httpParams = httpParams.append('cdFilial', cdFilial);
    httpParams = httpParams.append('isLogin', 'false');
    return this.httpClient.get<Banner[]>(
      this.configService.getEndereco() + '/banner/getAtivosPorFilial',
      {
        headers: this.configService.getHeaders(),
        params: httpParams
      }
    )
  }

  getBannersTelaLogin(): Observable<Banner[]> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const httpParams = new HttpParams().append('isLogin', 'true');
    return this.httpClient.get<Banner[]>(
      this.configService.getEndereco() + '/banner/getAtivosPorFilial',
      { headers, params: httpParams }
    );
  }

  getAll(): Observable<Banner[]> {
    this.jwtService.validarAcessToken();
    return this.httpClient.get<Banner[]>(
      this.configService.getEndereco() + '/banner/getAll',
      {
        headers: this.configService.getHeaders()
      }
    )
  }

  gravarBanner(banner: Banner) {
    this.jwtService.validarAcessToken();
    return this.httpClient.post(
      this.configService.getEndereco() + '/banner/gravar',
      JSON.stringify(banner),
      { headers: this.configService.getHeaders() }
    )
  }

  alterarBanner(banner: Banner) {
    this.jwtService.validarAcessToken();
    return this.httpClient.put(
      this.configService.getEndereco() + '/banner/alterar',
      JSON.stringify(banner),
      { headers: this.configService.getHeaders() }
    )
  }

  deletarBanner(id: string) {
    this.jwtService.validarAcessToken();
    let httpParams = new HttpParams();
    httpParams = httpParams.append('id', id.toString());
    return this.httpClient.delete(
      this.configService.getEndereco() + '/banner/deletar',
      {
        headers: this.configService.getHeaders(),
        params: httpParams
      }
    )
  }
}
